export enum SlaStatus {
  OnTime = 0,
  DueSoon = 1,
  Late = 2,
}

export const SlaStatusLabels: Record<SlaStatus, string> = {
  [SlaStatus.OnTime]: "On Time",
  [SlaStatus.DueSoon]: "Due Soon",
  [SlaStatus.Late]: "Late",
};
